import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { 
  Coins, 
  Gift, 
  Users, 
  Share2, 
  Trophy, 
  Sparkles,
  CheckCircle,
  FileText
} from 'lucide-react';
import './TphileTokenInfo.css';

const TphileTokenInfo = ({ isLoggedIn, referralCode }) => {
  const navigate = useNavigate();

  const handleCardClick = (cardType) => {
    switch(cardType) {
      case 'profile':
        if (isLoggedIn) {
          navigate('/profile-completion');
        } else {
          navigate('/login');
        }
        break;
      case 'predictions':
        navigate('/submit');
        break;
      case 'referrals':
        if (isLoggedIn && referralCode) {
          navigate(`/login?tab=referrals&code=${referralCode}`);
        } else {
          navigate('/login?tab=referrals');
        }
        break;
      case 'sharing':
        navigate('/submit');
        break;
      default:
        break;
    }
  };

  const earningMethods = [
    {
      icon: <Gift size={24} />,
      title: 'Complete Profile',
      amount: '4,500 TPHILE',
      description: 'Answer all profile questions',
      type: 'profile'
    },
    {
      icon: <Sparkles size={24} />,
      title: 'Quality Predictions',
      amount: 'Up to 500 TPHILE',
      description: 'Submit high-quality predictions',
      type: 'predictions'
    },
    {
      icon: <Users size={24} />,
      title: 'Refer Friends',
      amount: '10,000 TPHILE',
      description: 'Per verified active user',
      type: 'referrals'
    },
    {
      icon: <Share2 size={24} />,
      title: 'Social Sharing',
      amount: '100 TPHILE/day',
      description: 'Share predictions (max 5/day)',
      type: 'sharing'
    }
  ];

  return (
    <div className="tphile-token-section">
      <div className="tphile-token-container">
      <div className="tphile-header">
        <div className="tphile-badge">
          <Coins className="badge-icon" />
          <span>TPHILE TOKEN</span>
        </div>
        
        <h2 className="tphile-title">
          <span className="title-main">Earn Rewards for</span>
          <span className="title-accent">Quality Predictions</span>
        </h2>
        
        <p className="tphile-description">
        TPHILE is our native ERC-20 token on Polygon blockchain with a permanently capped supply of 1 billion tokens—no inflation, ever.
        Built on Polygon for fast, low-cost transactions, TPHILE transforms quality predictions into real value through AI-powered quality verification, rewarding only genuine insights scoring 70%+. Beyond earning tokens, TPH unlocks governance rights, premium features, and exclusive analyst predictions.
        </p>
        
        <Link to="/whitepaper" className="whitepaper-link">
          <FileText size={20} />
          <span>Read our full white paper</span>
        </Link>
      </div>

      <div className="earning-methods-grid">
        {earningMethods.map((method, index) => (
          <div 
            key={index} 
            className="earning-method-card"
            onClick={() => handleCardClick(method.type)}
            style={{ cursor: 'pointer' }}
          >
            <div className="method-icon-wrapper">
              {method.icon}
            </div>
            <h3 className="method-title">{method.title}</h3>
            <div className="method-amount">{method.amount}</div>
            <p className="method-description">{method.description}</p>
            <div className="method-check">
              <CheckCircle size={16} />
            </div>
          </div>
        ))}
      </div>

      <div className="tphile-highlights">
        <div className="highlight-item">
          <Trophy className="highlight-icon" />
          <div className="highlight-content">
            <h4>Quality-Gated Rewards</h4>
            <p>Only predictions scoring 70%+ earn tokens</p>
          </div>
        </div>
        
        <div className="highlight-item">
          <Sparkles className="highlight-icon" />
          <div className="highlight-content">
            <h4>Deflationary Model</h4>
            <p>Decreasing emission rate over 4 years</p>
          </div>
        </div>
        
        <div className="highlight-item">
          <Coins className="highlight-icon" />
          <div className="highlight-content">
            <h4>Multiple Utilities</h4>
            <p>Governance, premium access, and more</p>
          </div>
        </div>
      </div>

      </div>
    </div>
  );
};

export default TphileTokenInfo;